<template lang='pug'>
  v-card(style="border: solid 1px;")
    v-snackbar(v-model='snackbar.snackbar' :color='snackbar.color' :right="true" :timeout='snackbar.timeout' :top="true")
      | {{ snackbar.text }}
      v-btn(dark='' text='' @click='snackbar.snackbar = false')
        | {{$t('payment.general.close')}}
    v-card-title
      | Factura # {{item.reference_number}}
      v-spacer
        v-icon(aria-label="Close" @click="$emit('close')")
          | mdi-close
    v-card-text.body-1.text-center.mt-4
      p.mb-5 Punto: {{item.location_from.name}}
      //-
        v-btn.ml-9(v-if="item.delivery === 'delivery' && item.status === 'pending'" :loading="checkingAvailability" @click="checkAvailability" color="info" depressed="" default="" rounded="" style="padding: 7px !important") consultar costo domicilio
        v-row(v-if="item.delivery === 'delivery' && item.status === 'process'")
          v-btn.ml-9(:loading="checkingDeliveryHistory" @click="checkDeliveryHistory" color="info" depressed="" default="" rounded="" style="padding: 7px !important") consultar estado del domicilio
          p(style="align-self: center;") Estado: {{checkingDeliveryHistory ? 'Consultando...' : item.status}}
      v-row
        v-col
          p Nombre del cliente: {{item.client.fullName}}
        v-col
          p Teléfono: {{item.client.phone}}
      v-row
        v-col
          p Opción de entrega: {{item.delivery === 'delivery' ? 'Domicilio' : 'Buscar en el establecimiento'}}
        v-col
          p Dirección: {{item.client.direction.direction}}
      v-row
        table().ma-auto
          thead
            tr
              th.text-xs-left Cantidad
              th.text-xs-left Referencia
              th.text-xs-left Valor/Unidad
              th.text-xs-left Valor total
          tbody
            tr(v-for='row in item.items')
              th.text-xs-left {{row.amount}}
              td.text-xs-left(style='max-width: 100px;')
                a(@click.stop="showProduct(row)") {{row.name}}
              td.text-xs-left {{row.price}}
              td.text-xs-left {{row.price * row.amount}}
      v-row(v-if="item.coupon").ma-auto
        v-col
          p {{item.coupon.title}}
        v-col
          p Cupón: ${{item.coupon.value}}
      v-row(v-if="item.coupon")
        p.ma-auto
          b Valor Total Final:{{item.cash}}
      v-btn.mt-6(color="info" depressed="" default="" rounded="" :disabled="checkingAvailability || checkingDeliveryHistory" @click="$emit('close')")
        | Ok

</template>

<script>
  import Swal from 'sweetalert2'
  const formatter = new Intl.NumberFormat('es-US', {
    style: 'currency',
    currency: 'COP',
    minimumFractionDigits: 0,
  })
  export default {
    name: 'BillPreview',
    filters: {
      moneyFormat: function (value) {
        return formatter.format(value)
      },
      numberFormat (val) {
        if (val) { return '$' + val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.') }
        return '0 '
      },
      translate: function (name) {
        switch (name) {
          case 'sales':
            return 'Venta'

          case 'purchases':
            return 'Compra'

          case 'transfers':
            return 'Traslado'

          case 'returns':
            return 'Devolucion'

          case 'store':
            return 'Tienda'

          case 'warehouse':
            return 'Bodega'
        }
      },

    },
    props: {
      item: Object,
      currentType: String,
    },
    data () {
      return {
        checkingAvailability: false,
        snackbar: {
          color: '',
          snackbar: false,
          text: '',
          timeout: 6000,
        },
        checkingDeliveryHistory: false,
      }
    },
    methods: {
      checkAvailability () {
        const vm = this
        vm.checkingAvailability = true
        const payload = {
          lngInit: vm.item.location_from.addressInfo.lng,
          latInit: vm.item.location_from.addressInfo.lat,
        }
        vm.$store.dispatch('delivery/isDeliveryAvailable', payload).then((res) => {
          // res.acceptanceAnswer = 'OUT_OF_COVERAGE'
          if (res.acceptanceAnswer === 'ACCEPTED') {
            const info = {
              latInicial: vm.item.location_from.addressInfo.lat.toString(),
              lgnInicial: vm.item.location_from.addressInfo.lng.toString(),
              dirInicial: vm.item.location_from.addressInfo.addressgoogle,
              latFinal: vm.item.client.direction.location.lat.toString(),
              lgnFinal: vm.item.client.direction.location.lng.toString(),
              dirDestino: vm.item.client.direction.direction,
              idaRegreso: 'NO',
            }
            let deliveryCost
            vm.$store.dispatch('delivery/deliveryCost', info).then((resp) => {
              if (resp.success) {
                deliveryCost = resp.costo
                Swal.fire({
                  icon: 'success',
                  title: 'Costo del domicilio: ' + deliveryCost,
                  showCancelButton: true,
                  confirmButtonColor: '#3085d6',
                  cancelButtonColor: '#d33',
                  confirmButtonText: 'Aceptar Domicilio',
                  cancelButtonText: 'Cancelar Domicilio',
                }).then((result) => {
                  if (result.value) {
                    const service = {
                      userId: vm.item.client.id,
                      reference_number: vm.item.reference_number,
                      idaRegreso: 'NO',
                      dirInicial: vm.item.location_from.addressInfo.addressgoogle,
                      latInicial: vm.item.location_from.addressInfo.lat.toString(),
                      lgnInicial: vm.item.location_from.addressInfo.lng.toString(),
                      dirDestino: vm.item.client.direction.direction,
                      latFinal: vm.item.client.direction.location.lat.toString(),
                      lgnFinal: vm.item.client.direction.location.lng.toString(),
                      complementoInicial: '',
                      complementoDestino: '',
                      tipoPago: '1', // efectivo
                      valorMensajero: deliveryCost.toString(),
                      observacion: '',
                      valorCompra: vm.item.cash,
                    }
                    vm.$store.dispatch('delivery/createService', service).then((respt) => {
                      // console.log(respt)
                      /* if (res.success) {
                        vm.checkingAvailability = true
                      } */
                      vm.item.status = 'process'
                      vm.changeStatus(vm.item, 'process', 'green', 'Domiciliario contactado exitosamente')
                      vm.checkingAvailability = false
                    })
                  } else {
                    vm.changeStatus(vm.item, 'canceled', 'green', 'Orden cancelada')
                  }
                })
              }
            })
          } else {
            let msg
            if (res.acceptanceAnswer === 'REJECTED_PER_CAPACITY') {
              msg = 'No hay mensajeros disponibles en tu zona. Intenta de nuevo en unos minutos.'
            } else if (res.acceptanceAnswer === 'OUT_OF_COVERAGE') {
              msg = 'No hay cobertura de domicilios en tu zona.'
            }
            Swal.fire({
              icon: 'error',
              title: msg,
            }).then(() => {
              vm.checkingAvailability = false
            })
          }
        })
      },
      setDataNotification (ban, color, text) {
        this.snackbar.snackbar = ban
        this.snackbar.color = color
        this.snackbar.text = text
      },
      changeStatus (item, event, color, msg) {
        const idOrden = item.idOrden
        const uid = this.$store.state.users.user.uid
        const ban = true
        const data = {
          banClientAdmin: ban,
          idOrder: idOrden,
          statusOrder: event,
          idUser: uid,
        }
        if (event === 'completed') {
          if (item.referral !== '') {
            const shopOwner = item.user.id
            const shopId = item.location_from.id
            const dataRequest = { shopOwner: shopOwner, shopId: shopId, isReferral: true, uid: item.referral }
            this.$store.dispatch('promotions/addFirstBuyCoupon', dataRequest)
          }
        }
        this.$store.dispatch('transactions/updateStatusOrder', data).then((res) => {
          // console.log(res)
          this.setDataNotification(true, color, msg)
        })
      },
      checkDeliveryHistory () {
        const vm = this
        vm.checkingDeliveryHistory = true
        const data = {
          numServicio: '\'11228838\'',
        }
        vm.$store.dispatch('delivery/deliveryStatus', data).then((res) => {
          // console.log(res)
          vm.checkingDeliveryHistory = false
          if (res.success) {
            if (res.historial[0].estado_servicio === 'FINALIZADO') {
              vm.changeStatus(vm.item, 'completed', 'green', 'Orden completada')
              vm.item.status = 'completed'
            }
          }
        })
      },
      showSupportImage (item) {
        this.$emit('showSupportImage', item)
      },
      showProduct (item) {
        const vm = this
        vm.$store.dispatch('products/setCurrentItem', item).then(function () {
          vm.$emit('showProduct')
        })
      },
      handleStock (val, type) {
        if (type === 'stock') {
          val.trash = val.qty - val.stock
        } else {
          val.stock = val.qty - val.trash
        }
      },
      updateReturn () {
        const vm = this
        vm.$store.dispatch('transactions/updateReturn', vm.item).then(function () {
          vm.$emit('close')
        })
      },
    },

  }
</script>

<style scoped>
</style>
